import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';

@Component({
  selector: 'app-comment-dialog',
  templateUrl: './comment-dialog.component.html'
})
export class CommentDialogComponent implements OnInit {

  comment: string = "";
  constructor(@Optional() private dialogRef: MatDialogRef<CommentDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: string
  ) {}

  ngOnInit(): void {
    this.comment = this.data;  
  }

  cancel() {
    this.dialogRef.close({ event: MatDialogCloseEvent.SUCCESS });
  }
}
